
interface User {
    email: string;
    id: string;
    permissions: string[];
}

export default defineNuxtRouteMiddleware(async (to, from) => {
    try {
        const { session, fetchSession } = useAuth()
        let user_session: { user: User } | null = null

        if (!session.value) {
            user_session = await fetchSession()
        } else {
            user_session = session.value
        }

        const required_role = getRequiredRole(to.fullPath, 'GET', useAppConfig().cms?.routePermissions)

        if (!required_role) {
            console.error('Route not defined')
            return navigateTo('/')
        }
        if (required_role === 'public') return

        // `/login`, not `/`: a site extending this layer may serve its own page at `/`.
        if (!user_session?.user) return navigateTo('/login')

        if (!user_session.user.permissions.includes(required_role)) return navigateTo('/no-access')
    } catch (err) {
        console.error(err)
    }
})
